// extracted by mini-css-extract-plugin
module.exports = {"primary-color":"#005bbb","secondar-color":"#63ceca","accent-color":"#0089c4","black":"#000","white":"#fff","light-gray":"#f6f6f6","vortex-blue":"#008fbe"};